module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "s-actionsheet-container"
  }, [_c('c-navbar', {
    attrs: {
      "title": "20201111"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "newEleven-box"
  }, [_c('div', {
    staticClass: "qrcode-box"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("扫码添加客服 优惠活动抢先体验")]), _vm._v(" "), _c('div', {
    staticClass: "tag-box"
  }, [_c('span', {
    staticClass: "tag-title"
  }, [_vm._v("全年最低 错过等一年")]), _vm._v(" "), _c('div', {
    staticClass: "tag-version"
  }, [_c('div', {
    staticClass: "version__box1"
  }, [_c('div', {
    staticClass: "version__leftbox-left"
  }, [_c('span', {
    staticClass: "version__name"
  }, [_vm._v("行业终身版"), _c('span', [_vm._v("原价¥1888")])]), _vm._v(" "), _c('span', {
    staticClass: "version__desc"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("适用行业：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("餐饮/美业丽人/服装鞋帽/母婴亲子")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("数码电子/宠物/眼镜")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("赠送移动支付30天0费率")])]), _vm._v(" "), _c('span', {
    staticClass: "version__tips"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月1日08:00 -10日21:59 支付定金")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月11日00:00-23:59 支付尾款")])]), _vm._v(" "), _c('span', {
    staticClass: "version__dingjin"
  }, [_vm._v("\n                    定金¥100  尾款¥1488 \n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "version__leftbox-right",
    on: {
      "click": function($event) {
        _vm.buy(263)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("到手价¥1588")])])]), _vm._v(" "), _c('div', {
    staticClass: "version__box2"
  }, [_c('div', {
    staticClass: "version__rightbox-left"
  }, [_c('span', {
    staticClass: "version__name"
  }, [_vm._v("终身无忧开店套餐"), _c('span', [_vm._v("原价¥7288")])]), _vm._v(" "), _c('span', {
    staticClass: "version__desc"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("套餐包含：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("餐饮/美业丽人/服装鞋帽/母婴亲子")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("数码电子/宠物/眼镜+至尊会员卡+小程序plus终身")])]), _vm._v(" "), _c('span', {
    staticClass: "version__tips"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月1日08:00 -10日21:59 支付定金")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月11日00:00-23:59 支付尾款")])]), _vm._v(" "), _c('span', {
    staticClass: "version__dingjin"
  }, [_vm._v("\n                    定金¥100  尾款¥5788 \n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "version__rightbox-right",
    on: {
      "click": function($event) {
        _vm.buy(266)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("到手价¥5888")])])]), _vm._v(" "), _c('div', {
    staticClass: "version__box3"
  }, [_c('div', {
    staticClass: "version__rightbox-left"
  }, [_c('span', {
    staticClass: "version__name"
  }, [_vm._v("小程序终身"), _c('span', [_vm._v("原价¥3588")])]), _vm._v(" "), _c('span', {
    staticClass: "version__desc"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("直播带货 | 会员分销 | 会员在线储值 |  \n")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("分享转介绍 | 线上线下一体化 |")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("轻松开网店 ")])]), _vm._v(" "), _c('span', {
    staticClass: "version__free"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/2020-11-11/freeicon.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("行业终身版")])]), _vm._v(" "), _c('span', {
    staticClass: "version__tips"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月1日08:00 -10日21:59 支付定金")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月11日00:00-23:59 支付尾款")])]), _vm._v(" "), _c('span', {
    staticClass: "version__dingjin"
  }, [_vm._v("\n                    定金¥100  尾款¥3188  \n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "version__rightbox-right",
    on: {
      "click": function($event) {
        _vm.buy(265)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("到手价¥3288")])])]), _vm._v(" "), _c('div', {
    staticClass: "version__box4"
  }, [_c('div', {
    staticClass: "version__rightbox-left"
  }, [_c('span', {
    staticClass: "version__name"
  }, [_vm._v("至尊微信会员卡"), _c('span', [_vm._v("原价¥3588")])]), _vm._v(" "), _c('span', {
    staticClass: "version__desc"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("无需实体卡 | 扫码即领卡 | 卡样随心换 | ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("推送消息更方便 | 提高复购率")])]), _vm._v(" "), _c('span', {
    staticClass: "version__free"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/2020-11-11/freeicon.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("行业终身版")])]), _vm._v(" "), _c('span', {
    staticClass: "version__tips"
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月1日08:00 -10日21:59 支付定金")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("11月11日00:00-23:59 支付尾款")])]), _vm._v(" "), _c('span', {
    staticClass: "version__dingjin"
  }, [_vm._v("\n                    定金¥100  尾款¥3188 \n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "version__rightbox-right",
    on: {
      "click": function($event) {
        _vm.buy(264)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("到手价¥1588")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tag2-box"
  }, [_c('span', {
    staticClass: "tag2-box__title"
  }, [_vm._v("开店利器 付100抵300")]), _vm._v(" "), _c('ul', {
    staticClass: "version__list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: "index",
      on: {
        "click": function($event) {
          _vm.buy(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (item.type === 'normal') ? _c('span', [_vm._v(_vm._s(item.rule))]) : _c('span', [_c('span', {
      staticStyle: {
        "color": "white",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.rule)), _c('span', {
      staticStyle: {
        "color": "#F8CEA9"
      }
    }, [_vm._v(_vm._s(item.tips))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "white",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.rule1)), _c('span', {
      staticStyle: {
        "color": "#F8CEA9"
      }
    }, [_vm._v(_vm._s(item.tip1))])])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.price))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "logo-box"
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-567af745","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/2020-11-11/index.vue
// module id = 1048
// module chunks = 2